<template>
  <div class="main-content">
    <div class="app-main-inner-row" style="height: 100%;min-height: 870px;">
      <div :class="gridClass" style="width:15%;min-width:190px;border:1px solid #ccc;display: flex;cursor: pointer">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="trackingTemplateTree.gridOptions"
          :column-defs="trackingTemplateTree.columnDefs"
          :row-data="trackingTemplateTree.rowData"
          style="width:100%;height:100%;min-height: 500px;"
        />
      </div>
      <div v-show="optModule.template" :class="gridClass" style="width:15%;min-width:190px;border:1px solid #ccc;display: flex;cursor: pointer">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="trackingTree.gridOptions"
          :column-defs="trackingTree.columnDefs"
          :row-data="trackingTree.rowData"
          style="width:100%;height:100%;min-height: 500px;"
        />
      </div>
      <div style="min-width:85%;border:1px solid #ccc;height: 100%">
        <div v-show="!isPlatform && !(optModule.tracking || optModule.trackingDetail)" class="section" style="height: 100%">
          <div v-show="!isPlatform" style="height: 28px; margin: 16px">
            <el-button v-show="opStatus === 'read'" type="primary" @click="onNewSopTemplate()">{{ $t('CargoMsg.Cargo_NewSopTemplate') }}</el-button>
            <el-button v-show="opStatus === 'read' && (trackingTemplate ? trackingTemplate.type === 1 : true)" type="primary" @click="onEditSopTemplateConfig()">{{ $t('SystemMaintenance.TemplateApplicationSettings') }}</el-button>
            <el-button v-show="opStatus === 'read'" :disabled="!hasChooseTemplate" type="primary" @click="onCopySopTemplate()">{{ $t('CargoMsg.Cargo_CopySopTemplate') }}</el-button>
            <el-button v-show="opStatus === 'read'" :disabled="!hasChooseTemplate" type="primary" @click="onEditSopTemplate()">{{ $t('CargoMsg.Cargo_EditSopTemplate') }}</el-button>
            <el-button v-show="opStatus === 'read' && !trackingTemplate.sopStatus" :disabled="!hasChooseTemplate" type="primary" @click="onUpdateTenantSopStatus()">{{ $t('CargoMsg.Cargo_EnableSopTemplate') }}</el-button>
            <el-button v-show="opStatus === 'read' && trackingTemplate.sopStatus" :disabled="!hasChooseTemplate" type="primary" @click="onUpdateTenantSopStatus()">{{ $t('CargoMsg.Cargo_UnableSopTemplate') }}</el-button>
            <el-button v-show="opStatus === 'read'" :disabled="!hasChooseTemplate" type="danger" @click="onDeleteSopTemplate()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <el-button v-show="opStatus !== 'read'" type="primary" @click="onSaveSopTemplate()">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
            <el-button v-show="opStatus !== 'read'" type="default" @click="onCancelSopTemplate()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          </div>
          <sop-template-form
            v-show="!isPlatform && (hasChooseTemplate || opStatus !== 'read')"
            ref="sopTemplateForm"
            :op-status="opStatus"
            :platform-data.sync="platformData"
            :form.sync="trackingTemplate"
            :open-subscribe="openSubscribe"
          />
        </div>
        <div v-show="(optModule.tracking || optModule.trackingDetail || (hasChooseTemplate && isPlatform))" class="section" style="height: 100%">
          <div style="height: 28px; margin: 16px">
            <el-button v-show="opStatus === 'read'" type="primary" @click="onNewNode()">{{ $t('CargoMsg.Cargo_NewNode') }}</el-button>
            <el-button v-show="opStatus === 'read'" type="primary" @click="onNewNodeStatus()">{{ $t('CargoMsg.Cargo_NewNodeStatus') }}</el-button>
            <el-button v-show="opStatus === 'read'" type="primary" @click="onEdit()">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-show="opStatus === 'read'" type="danger" @click="onDelete()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <el-button v-show="opStatus !== 'read'" type="primary" @click="onSave()">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
            <el-button v-show="opStatus !== 'read'" type="default" @click="onCancel()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          </div>
          <el-tabs v-model="activateTab" type="card" style="margin-left: 16px" @tab-click="handleTabClick">
            <el-tab-pane v-if="optModule.tracking" key="nodeSettings" name="nodeSettings" :label="$t('CargoMsg.Cargo_NodeSettings')" lazy>
              <tracking-form
                ref="nodeSettings"
                key="nodeSettings"
                :template-tree-data="trackingTemplateTree.rowData"
                type="nodeSettings"
                :op-status.sync="opStatus"
                :tracking-form.sync="tracking"
                :tracking-template-form.sync="trackingTemplate"
                :platform-data.sync="platformData"
                :pre-tracking-options="preTrackingOptions"
                :tracking-details="trackingDetails"
                :priority-conditions="priorityConditions"
                :specific-business-rules="specificBusinessRules"
                :tenant-instructions="tenantInstructions"
                @refresh="refresh"
              />
            </el-tab-pane>
            <el-tab-pane v-if="optModule.trackingDetail" key="nodeStatus" name="nodeStatus" :label="$t('CargoMsg.Cargo_NodeStatusSettings')" lazy>
              <tracking-detail-form
                ref="nodeStatus"
                key="nodeStatus"
                type="nodeStatus"
                :op-status.sync="opStatus"
                :tracking-detail.sync="trackingDetail"
                :current-lob.sync="lob"
                :state-with-node-codes="stateWithNodeCodes"
                :is-platform-code="isPlatformTrackingDetailCode"
                :trigger-types="triggerTypes"
                :report-template-list="reportTemplateList"
                :doc-type-map="docTypeMap"
                :sop-external-code-config-list="sopExternalCodeConfigList"
                :tracking-options="trackingOptions"
                :tracking-detail-options="trackingDetailOptions"
              />
            </el-tab-pane>
            <el-tab-pane v-if="optModule.trackingDetail" key="alertSettings" name="alertSettings" :label="$t('CargoMsg.Cargo_AlertSettings')" lazy>
              <alert-settings-form ref="alertSettings" key="alertSettings" type="alertSettings" :default-warn-name.sync="defaultWarnName" :op-status.sync="opStatus" :form.sync="trackingDetail.warningRuleVO" :lob="lob" :sop-template-code-list="sopTemplateCodeList" :template-complete-node-status.sync="templateCompleteNodeStatus" />
            </el-tab-pane>
            <el-tab-pane v-if="optModule.trackingDetail" key="sopMessageSetting" name="sopMessageSetting" :label="$t('CargoMsg.Cargo_ConfigureSopMessagePush')" lazy>
              <sop-message-setting-form ref="sopMessageSetting" key="sopMessageSetting" :lob.sync="lob" :op-status.sync="opStatus" type="sopMessageSetting" :tracking-list="trackingTree.rowData" :tracking-detail.sync="trackingDetail" :file-tree-map="fileTreeMap" :multiple-trigger="multipleTrigger" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- SOP模板配置弹窗 -->
    <sop-template-config-dialog :visible.sync="sopTemplateConfigDialog.visible" :lob="lob" />
  </div>
</template>

<script>
import {
  copySopTemplate,
  deleteTrackingByKey,
  deleteTrackingDetailByKey,
  delTenantSopTemplate,
  getDocTypeByLob,
  getOpenSubscribe,
  getPlatformSopInfo,
  getTenantSopTemplate,
  getTenantSopTemplateDetail,
  getTrackingByUuid, queryCompleteTrackingDetails,
  queryNodeTreeByTemplateKey,
  queryTrackingDetailByKey,
  saveTenantSopTemplate,
  saveTracking,
  saveTrackingDetailInfo,
  updateTenantSopStatus
} from '@/api/sysManage/baseConfig/businessManage'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import Tracking from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/business/tracking'
import TrackingDetail from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/business/trackingDetail'
import TrackingForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/trackingForm'
import TrackingDetailForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/trackingDetailForm'
import AlertSettingsForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/alertSettingsForm'
import SopMessageSettingForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/sopMessageSettingForm'
import { deepClone } from '@/utils'
import SopTemplateForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/sopTemplate/sopTemplateForm'
import StrUtils from '@/utils/StrUtils'
import { Assert } from '@/utils/validate'
import * as entityTriggerTypeApi from '@/api/sysManage/baseConfig/entityTriggerType'
import * as templateApi from '@/api/sysManage/baseConfig/template'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import * as sopExternalCodeConfigApi from '@/api/sysManage/baseConfig/sopExternalCodeConfig'
import { getSopWtPriorityConditionEnums } from '@/api/sop'
import { queryAllTenantInstruction, querySpecificBusinessRuleByTenant } from '@/api/sysManage/baseConfig/instruction'
import SopTemplateConfigDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/sopTemplateConfigDialog'

export default {
  name: 'TenantBusinessStatusManagement',
  components: { SopTemplateForm, SopMessageSettingForm, AlertSettingsForm, TrackingDetailForm, TrackingForm, TrackingDetail, Tracking, SopTemplateConfigDialog },
  filters: {},
  data() {
    return {
      activateTab: 'nodeSettings',
      loading: false,
      currentState: {
        treeNode: {} // 当前点击的节点
      },
      hasChooseTemplate: false,
      isPlatformTrackingDetailCode: false,
      pendTabSet: new Set(),
      trackingMap: new Map(),
      trackingDetailMap: new Map(),
      tracking: {
        trackingWtPositions: [],
        trackingWtPreNodes: [],
        trackingWtPriority: {},
        trackingWtSpecificBusinessRule: {},
        trackingWtInstructions: []
      },
      trackingDetail: {},
      trackingTemplate: {
        innerConfig: {
          sales: true,
          overseaOp: false,
          dc: false,
          planner: false,
          op: true,
          csr: false,
          post: true,
          personnel: false,
          cargoSales: false,
          siteOp: false,
          userDefinedRoleId1: false, // 自定义岗位1
          userDefinedRoleId2: false, // 自定义岗位2
          userList: [], // 用户id逗号隔开
          email: true,
          stationNotice: false,
          weChat: false,
          bellMsg: false,
          enterpriseWechat: false
        }
      },
      sopTemplateCodeMap: {}, // 用来匹配预警条件
      platformData: {}, // 平台数据
      fileTreeMap: {}, // 文件类型
      docTypeMap: {}, // 文件类型
      opStatus: 'read',
      optModule: { // 操作
        template: false,
        tracking: false,
        trackingDetail: false
      },
      triggerTypes: [],
      reportTemplateList: [],
      openSubscribe: null, // 是否开通港区服务
      sopExternalCodeConfigList: [],
      selectTrackingTreeRow: null,
      templateCompleteNodeStatus: [],
      trackingTemplateTree: {
        columnDefs: [],
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: false,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            width: 280,
            cellStyle: (params) => {
              if (params.data.sopStatus || params.data.type === 1) {
                return { color: '' }
              }
              return { color: 'gray' }
            },
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                let name = params.data.chineseName
                if (!params.data.sopStatus) {
                  name += this.$t('CargoMsg.Cargo_Disabled2')
                }
                if (params.data.type === 1) {
                  return params.data.chineseName
                }
                if (SystemConstants.getCommonState(params.data.parentUuid, SystemConstants.LOBS)) {
                  return `${params.data.serialNumber}.` + name
                }
                return `${params.data.serialNumber}.` + name
              },
              checkbox: (params) => {
                return false
              }
            },
            tooltipField: 'chineseName'
          },
          onRowClicked: this.onTemplateRowClick
        }
      },
      trackingTree: {
        columnDefs: [],
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: false,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            width: 280,
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                const name = this.isZh ? params.data.chineseName : params.data.englishName
                if (params.data.type === 1) {
                  return name
                }
                if (SystemConstants.getCommonState(params.data.parentUuid, SystemConstants.LOBS)) {
                  return `${params.data.level}.` + name
                }
                return `${params.data.level}.` + name
              },
              checkbox: (params) => {
                return false
              }
            },
            tooltipField: 'chineseName'
          },
          onRowClicked: this.onRowClick
        }
      },
      updateTenantSopStatusDialog: {
        visible: false,
        tips: ''
      },
      trackings: [],
      trackingDetails: [],
      preTrackingOptions: [],
      priorityConditionMap: new Map(), // map<lob , list<条件>> 优先级 条件项
      priorityConditions: [], // 优先级 条件项 下拉框
      specificBusinessRules: [], // 特定业务规则
      tenantInstructions: [], // 租户操作指令
      trackingOptions: [], // 节点选项
      trackingDetailOptions: [], // 节点状态选项
      sopTemplateConfigDialog: {
        visible: false
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    lob() {
      const lob = !this.trackingTemplate ? 'SE' : (this.trackingTemplate.parentUuid || this.trackingTemplate.code)
      return !lob ? this.trackingTemplate.lob : lob
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    },
    platformTrackingList() {
      const lob = this.lob
      if (this.platformData && this.platformData.hasOwnProperty(lob)) {
        return this.platformData[lob].trackingList
      }
      return []
    },
    stateWithNodeCodes() {
      const lob = this.lob
      if (this.platformData && this.platformData.hasOwnProperty(lob)) {
        return this.platformData[lob].stateWithNodeCodes
      }
      return {}
    },
    gridClass() {
      return this.opStatus !== 'read' ? 'section grid-wrapper grid-disable' : 'section grid-wrapper'
    },
    defaultWarnName() {
      const tracking = this.getTracking()
      return (tracking.chineseName || '') + '-' + (this.trackingDetail.codeCname || '')
    },
    sopTemplateCodeList() {
      return this.trackingTemplate ? this.sopTemplateCodeMap[this.trackingTemplate.uuid] : []
    },
    multipleTrigger() {
      if (this.triggerTypes && this.triggerTypes.length > 0) {
        const triggerObj = this.triggerTypes.find(op => op.uuid === this.trackingDetail.event)
        return triggerObj ? triggerObj.multipleTrigger : false
      }
      return false
    }
  },
  watch: {
    activateTab() {
      this.handleTabClick()
    }
  },
  async mounted() {
    this.initData()
    await this.fetchTreeData()
    // 默认选中第一行
    this.trackingTemplateTree.gridOptions.api.setFocusedCell(1, this.trackingTemplateTree.gridOptions.api.columnController.getAllDisplayedColumns()[0])
    const cell = this.trackingTemplateTree.gridOptions.api.getFocusedCell()
    const nodes = this.trackingTemplateTree.gridOptions.api.rowModel.rowsToDisplay
    const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
    this.onTemplateRowClick({ node: node })
    // sop 工作任务 优先级 条件项 下拉框
    try {
      await getSopWtPriorityConditionEnums().then(async(res) => {
        this.priorityConditionMap = res.data
      })
    } catch (e) {
      // error
    }
  },
  activated() {
    this.initTenantInstructionAndRule()
  },
  methods: {
    initData() {
      if (!this.triggerTypes || this.triggerTypes.length === 0) {
        entityTriggerTypeApi.queryPlatformAndTenantList().then(resp => {
          this.triggerTypes = resp.data
        })
      }
      if (!this.reportTemplateList || this.reportTemplateList.length === 0) {
        templateApi.getTemplateList({ templateUsage: 1 }).then(resp => {
          this.reportTemplateList = resp.data
        })
      }
      if (!this.sopExternalCodeConfigList || this.sopExternalCodeConfigList.length === 0) {
        sopExternalCodeConfigApi.querySopExternalCode().then(resp => {
          this.sopExternalCodeConfigList = resp.data
        })
      }
      if (this.openSubscribe === null) {
        getOpenSubscribe().then(resp => {
          this.openSubscribe = resp.data
        })
      }
    },
    initTenantInstructionAndRule() {
      // 查询 租户 操作指令
      queryAllTenantInstruction({}).then(res => {
        this.tenantInstructions = res.data
      })
      // 查询 特定业务规则
      querySpecificBusinessRuleByTenant({ paging: false }).then(res => {
        this.specificBusinessRules = res.data.list
      })
    },
    async fetchTreeData() {
      this.loading = getLoading()
      return getTenantSopTemplate().then(res => {
        this.trackingTemplateTree.rowData = res.data.filter(row => {
          // 截取path，过滤出五大业务及其叶子节点
          const arr = row.path.split(',')
          if (arr.length > 1) {
            return SystemConstants.getCommonState(arr[0], SystemConstants.LOBS)
          }
          return row.root
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    async onTemplateRowClick(event) {
      if (this.opStatus !== 'read') {
        return
      }
      const data = event.node.data
      this.optModule.tracking = false
      this.optModule.trackingDetail = false
      this.trackingTemplate = data
      if (!data.uuid || data.uuid.length < 10) {
        this.optModule.template = false
        this.hasChooseTemplate = false
        await this.loadPlatformInfo()
        return
      }
      this.hasChooseTemplate = true
      this.trackingTree.gridOptions.api.clearFocusedCell()
      this.trackingTree.gridOptions.api.refreshCells({ force: true })
      this.optModule.template = true
      this.loadTrackingTree()
      await this.loadPlatformInfo()
      this.loadSopTemplate('read')
    },
    loadTrackingTree() {
      const data = this.trackingTemplate
      this.loading = getLoading()
      queryNodeTreeByTemplateKey({ uuid: data.uuid }).then(res => {
        this.trackingTree.rowData = res.data
        this.parsingCode(res.data, data.uuid)
        // sop 提取tracking
        this.trackings = this.trackingTree.rowData.filter(item => item.type === 2)
        // sop 提取trackingDetail
        this.trackingDetails = this.trackingTree.rowData.filter(item => item.type === 3)
      }).finally(() => {
        this.loading.close()
      })
      queryCompleteTrackingDetails({ sopTemplateKey: data.uuid }).then(res => {
        this.templateCompleteNodeStatus = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowClick(event) {
      if (this.opStatus !== 'read') {
        return
      }
      this.toMountView(event.node.data, event.node, [1, 2].includes(event.node.data.type) ? 'tracking' : 'trackingDetail')
    },
    toMountView(rowData, node, viewName) {
      this.optModule.tracking = false
      this.optModule.trackingDetail = false
      this.$nextTick(() => {
        this.currentState.treeNode = { ...rowData, hasChild: node ? node.hasChildren() : false }
        this.optModule[viewName] = true
        if (viewName === 'tracking') {
          this.loadTracking(node.data.uuid)
        }
        if (viewName === 'trackingDetail') {
          this.loadTrackingDetail(node.data.uuid)
        }
      })
    },
    loadTracking(uuid) {
      console.info('platformTrackingList', this.platformTrackingList)
      if (this.trackingMap.has(uuid)) {
        const data = this.trackingMap.get(uuid)
        this.initTracking(data)
        return
      }
      const loading = getLoading()
      getTrackingByUuid(uuid).then(res => {
        const data = res.data
        this.trackingMap.set(data.uuid, data)
        this.initTracking(data)
      }).finally(() => loading.close())
    },
    initTracking(data) {
      this.activateTab = 'nodeSettings'
      const newData = deepClone(data)
      newData.applicationScope = 0
      newData.applicationTemplate = ''
      // sop 岗位
      if (!newData.trackingWtPositions) {
        newData.trackingWtPositions = []
      }
      // sop 特定业务规则
      if (!newData.trackingWtSpecificBusinessRule) {
        newData.trackingWtSpecificBusinessRule = {}
      }

      this.tracking = newData
      // sop 前置节点 tracking 下拉框
      this.preTrackingOptions = this.trackings.filter(item => item.uuid !== this.tracking.uuid)
      // sop 前置节点 trackingDetail 下拉框
      if (this.tracking.trackingWtPreNodes && this.tracking.trackingWtPreNodes.length > 0) {
        this.tracking.trackingWtPreNodes.forEach(trackingWtPreNode => {
          trackingWtPreNode.trackingDetails = this.trackingDetails.filter(item => item.parentUuid === trackingWtPreNode.preTrackingUuid)
        })
      }
      // sop 优先级 条件项 下拉框
      this.priorityConditions = this.priorityConditionMap[this.tracking.lob]
      this.handleTabClick()
    },
    // 加载节点状态
    loadTrackingDetail(uuid) {
      if (this.trackingDetailMap.has(uuid)) {
        const data = this.trackingDetailMap.get(uuid)
        this.initTrackingDetail(data)
        return
      }
      const loading = getLoading()
      let currentOfficeId = this.$store.getters.currentOfficeId
      // 如果是平台维护则让currentOfficeId为0，防止取不到currentOfficeId传参错误
      if (this.$store.getters.tenantId === 1) {
        currentOfficeId = 0
      }
      queryTrackingDetailByKey(uuid, currentOfficeId).then(res => {
        const data = res.data
        this.trackingDetailMap.set(data.uuid, data)
        this.initTrackingDetail(data)
      }).catch((err) => {
        console.log('error--.>', err)
      }).finally(() => {
        loading.close()
      })
    },
    initTrackingDetail(data) {
      const trackingDetail = deepClone(data)
      if (!trackingDetail.warningRuleVO) {
        trackingDetail.warningRuleVO = { warningDateField: 0, triggerTrackingDetailUuid: '', content: '', trackingDetailUuid: data.uuid, warningRuleItemList: [], open: null, level: null, ignoreType: null, ignoreTime: null, notifyJobType: 0 }
      }
      trackingDetail.applicationScope = 0
      this.trackingDetail = trackingDetail
      const curTrackingUuid = trackingDetail.parentUuid || trackingDetail.trackingUuid
      const curTracking = this.trackingTree.rowData.find(item => item.uuid === curTrackingUuid) || this.tracking
      const trackingOptions = this.trackingTree.rowData.filter(item => item.type === 2 && item.level < curTracking.level).map(item => ({ ...item }))
      const trackingDetailOptions = []
      for (const tracking of trackingOptions) {
        const details = this.trackingTree.rowData.filter(item => item.type === 3 && item.parentUuid === tracking.uuid).map(item => ({ ...item, parentCode: tracking.code }))
        trackingDetailOptions.push(...details)
      }
      this.trackingOptions = trackingOptions
      this.trackingDetailOptions = trackingDetailOptions
      this.activateTab = 'nodeStatus'
      this.handleTabClick()
    },
    handleTabClick() {
      this.$nextTick(async() => {
        if (this.optModule.trackingDetail) {
          //
          this.isPlatformTrackingDetailCode = this.checkTrackingDetailCode()
          this.pendTabSet.add(this.activateTab)
        } else {
          this.pendTabSet = new Set()
        }
        await this.$refs[this.activateTab].onShow()
      })
    },
    checkTrackingDetailCode() {
      if (this.isPlatform) {
        return false
      }
      const trackingCode = this.getTrackingCode()
      const platformData = this.platformData[this.lob]
      const trackingList = platformData.trackingList
      if (trackingList && trackingList.length > 0) {
        const tracking = trackingList.filter(data => data.code === trackingCode)
        if (tracking && tracking.length > 0) {
          const trackingKey = tracking[0].uuid
          const trackingDetailList = platformData.allTrackingDetails
          if (trackingDetailList && trackingDetailList.length > 0) {
            const trackingDetails = trackingDetailList.filter(item => item.trackingUuid === trackingKey)
            if (trackingDetails && trackingDetails.length > 0) {
              const trackingDetailCode = this.trackingDetail.code
              const hasTrackingDetail = trackingDetails.filter(item => item.code === trackingDetailCode)
              return hasTrackingDetail && hasTrackingDetail.length > 0
            }
          }
        }
      }
      return false
    },
    // 新建SOP模板
    onNewSopTemplate() {
      this.optModule.template = false
      this.opStatus = 'add'
      const lob = this.lob
      const level = this.getSopTemplateLevel(this.trackingTemplateTree, lob)
      const newSopTemplate = {
        uuid: '',
        serialNumber: level,
        lob: lob,
        templateName: '',
        branch: '',
        containerLoadType: '',
        localService: '',
        customs: '',
        ams: '',
        cargoSource: '',
        cargoType: '',
        freightTerm: '',
        freightTermHbl: '',
        displayOnTheHomepage: false,
        department: '',
        remark: '',
        soc: '',
        customsClaim: '',
        customsMethod: '',
        transfering: '',
        trans: '',
        bookingTerm: '',
        chooseNodeCode: [],
        chooseNodeStatusCode: [],
        moreConditions: '{}',
        innerConfig: {
          sales: true,
          overseaOp: false,
          dc: false,
          planner: false,
          op: true,
          csr: false,
          post: true,
          personnel: false,
          cargoSales: false,
          userDefinedRoleId1: false, // 自定义岗位1
          userDefinedRoleId2: false, // 自定义岗位2
          userList: [], // 用户id逗号隔开
          email: true,
          stationNotice: false,
          weChat: false,
          bellMsg: false,
          enterpriseWechat: false
        },
        sopStatus: false, // sop模板禁用状态，false--禁用，true--启用
        onlyApplyBranchAndHq: false,
        onlyApplyDepartmentAndHq: false
      }
      this.trackingTemplate = newSopTemplate
      this.$nextTick(() => {
        this.$refs['sopTemplateForm'].onShow()
      })
    },
    // 编辑SOP模板配置
    onEditSopTemplateConfig() {
      this.sopTemplateConfigDialog.visible = true
    },
    loadSopTemplate(opStatus) {
      if (!this.hasChooseTemplate) {
        return
      }
      getTenantSopTemplateDetail({ key: this.trackingTemplate.uuid }).then(res => {
        this.trackingTemplate = res.data
        this.optModule.template = true
        this.opStatus = opStatus
        this.$nextTick(() => {
          this.$refs['sopTemplateForm'].onShow()
        })
      })
    },
    // 编辑SOP模板
    onEditSopTemplate() {
      this.loadSopTemplate('edit')
    },
    // 复制SOP模板
    async onCopySopTemplate() {
      if (!this.hasChooseTemplate) {
        return
      }
      await this.$confirm(this.$t('Sop.copyTrackingTemplateConfirm', [this.trackingTemplate.templateName]), this.$t('common.tips.confirm'), {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      })
      this.loading = getLoading()
      copySopTemplate({ key: this.trackingTemplate.uuid }).then(async res => {
        this.$message.success(this.$t('SeaExport.CopySuccess'))
        await this.fetchTreeData()
        this.opStatus = 'read'
        const node = this.selectTemplateRow()
        await this.onTemplateRowClick({ node: node })
      }).finally(() => {
        this.loading.close()
      })
    },
    // 删除SOP模板
    async onDeleteSopTemplate() {
      const flag = await this.deleteConfirm()
      if (!flag) {
        return
      }
      this.loading = getLoading()
      delTenantSopTemplate({ key: this.trackingTemplate.uuid }).then(async res => {
        this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        await this.fetchTreeData()
        this.opStatus = 'read'
        const node = this.selectTemplateRow()
        await this.onTemplateRowClick({ node: node })
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存SOP模板
    onSaveSopTemplate() {
      const body = deepClone(this.trackingTemplate)
      if (StrUtils.isEmpty(body.templateName)) {
        this.$message.warning(this.$t('Message.pleaseEnterTemplateName'))
        return
      }
      body.hasChoosePerson = this.hasChoosePerson(body.innerConfig, ['sales', 'overseaOp', 'dc', 'planner', 'op', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'email'])
      if (body.innerConfig) {
        body.innerConfig.userList = body.innerConfig.userList ? body.innerConfig.userList.join(',') : ''
        body.innerConfig = JSON.stringify(body.innerConfig)
      }
      this.loading = getLoading()
      saveTenantSopTemplate(body).then(async res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        if (this.opStatus === 'edit') {
          this.reloadTemplateTree(this.trackingTemplate.templateName, this.trackingTemplate.serialNumber)
          this.opStatus = 'read'
          this.loadTrackingTree()
        }
        if (this.opStatus === 'add') {
          await this.fetchTreeData()
          const node = this.selectTemplateRow()
          this.opStatus = 'read'
          await this.onTemplateRowClick({ node: node })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 取消编辑SOP模板
    onCancelSopTemplate() {
      this.opStatus = 'read'
      const node = this.selectTemplateRow()
      this.onTemplateRowClick({ node: node })
    },
    onNewNode() {
      this.optModule.tracking = true
      this.optModule.trackingDetail = false
      const lob = this.lob
      const level = this.getLevel(this.trackingTree)
      this.tracking = {
        uuid: '',
        lob: lob,
        level: level,
        stateType: '',
        code: '',
        codeCname: '',
        codeEname: '',
        nodeType: 1,
        published: '',
        offsetDay: 0,
        offsetHour: 0,
        quickConfiguration: false,
        remark: '',
        trackingTemplateUuid: this.trackingTemplate.uuid,
        fba: false, // 是否FBA
        applicationScope: 0, // 0:仅当前模板添加/仅当前模板修改 1:添加到同业务类型下其他模板中/修改所有包含该节点的模板
        applicationTemplate: '',
        workTaskIgnoreMaster: false,
        sopBoardNotShow: false,
        allowTriggerRollback: false,
        trackingWtPositions: [],
        trackingWtPreNodes: [],
        trackingWtPriority: {},
        trackingWtSpecificBusinessRule: {},
        trackingWtInstructions: []
      }
      this.opStatus = 'add'
      this.activateTab = 'nodeSettings'
      this.handleTabClick()
    },
    onNewNodeStatus() {
      const level = this.getNewTrackingDetailLevel()
      const trackingDetailForm = {
        acrossTenant: false,
        applyType: 0,
        clientRefCode: '',
        code: '',
        codeCname: '',
        codeEname: '',
        defaultNode: false,
        dirty: false,
        documentTypeUuid: '',
        event: '',
        extendedData: '',
        externalCode: '',
        innerConfig: {
          sales: true,
          overseaOp: false,
          dc: false,
          planner: false,
          op: true,
          csr: false,
          post: true,
          personnel: false,
          cargoSales: false,
          siteOp: false,
          userDefinedRoleId1: false, // 自定义岗位1
          userDefinedRoleId2: false, // 自定义岗位2
          userList: [], // 用户id逗号隔开
          email: true,
          stationNotice: false,
          weChat: false,
          bellMsg: false,
          enterpriseWechat: false
        },
        level: level,
        published: false,
        remark: '',
        sendInnerNotify: false,
        notifyJobType: 0,
        valueChangePushMsg: false,
        externalInterfaceCode: '',
        externalInterfaceList: [],
        valueChangePushInterface: false,
        internalEventCode: 0,
        stateType: 1,
        templateUuid: '',
        trackingUuid: this.getParentUuid(),
        type: false,
        uuid: '',
        trackingTemplateConfigVOList: [],
        applicationScope: 0, // 0:仅当前模板添加/仅当前模板修改 1:添加到所有同节点的模板下/修改所有包含该节点的模板
        nodeStatusRollbackList: [],
        nodeStatusRollbackDelKeys: []
      }
      this.optModule.tracking = false
      this.optModule.trackingDetail = true
      trackingDetailForm.warningRuleVO = { warningDateField: 0, triggerTrackingDetailUuid: '', content: '', open: 0, ruleItem: '1', ignoreType: 1, ignoreTime: 24, level: 1, duration: 48, action: 0, trackingDetailUuid: '', lob: this.lob, warningRuleItemList: [], notifierRoles: '1,2', enableMail: 1, notifyJobType: 0 }
      this.trackingDetail = trackingDetailForm
      this.activateTab = 'nodeStatus'
      this.opStatus = 'add'
      this.handleTabClick()
    },
    onEdit() {
      this.opStatus = 'edit'
      this.handleTabClick()
    },
    async onDelete() {
      if (this.optModule.tracking) {
        // 删除节点
        await this.$confirm(this.$t('Sop.DelTrackingConfirm'), this.$t('common.tips.confirm'), { dangerouslyUseHTMLString: true, type: 'warning' })
        this.loading = getLoading()
        deleteTrackingByKey({ key: this.tracking.uuid }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.trackingMap.delete(this.tracking.uuid)
          this.loadTrackingTree()
          this.optModule.tracking = false
          // this.trackingTree.gridOptions.api.updateRowData({ 'remove': this.tracking })
          // const node = this.selectTrackingRow()
          // this.toMountView(node.data, node, [1, 2].includes(node.data.type) ? 'tracking' : 'trackingDetail')
        }).finally(() => {
          this.loading.close()
        })
      }
      if (this.optModule.trackingDetail) {
        // 删除节点状态
        await this.$confirm(this.$t('common.tips.confirmDelete') + `<span style="color:red">` + this.$t('Sop.DelTrackingDetailConfirm') + `</span>`, this.$t('common.tips.confirm'), { dangerouslyUseHTMLString: true, type: 'warning' })
        this.loading = getLoading()
        deleteTrackingDetailByKey({ key: this.trackingDetail.uuid }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.trackingDetailMap.delete(this.trackingDetail.uuid)
          this.loadTrackingTree()
          this.optModule.trackingDetail = false
          // this.trackingTree.gridOptions.api.updateRowData({ 'remove': this.trackingDetail })
          // const node = this.selectTrackingRow()
          // this.toMountView(node.data, node, [1, 2].includes(node.data.type) ? 'tracking' : 'trackingDetail')
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    async deleteConfirm() {
      let flag = false
      await this.$confirm(this.$t('CargoMsg.Cargo_DeleteOrNot'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        showClose: false,
        type: 'warning'
      }).then(async() => {
        flag = true
      }).catch(() => {
        flag = false
      })
      return flag
    },
    async onSave() {
      if (this.optModule.tracking) {
        // 保存节点
        await this.checkTrackingForm()
        this.loading = getLoading()
        saveTracking(this.tracking, this.tracking.uuid).then(async res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          if (this.opStatus === 'edit') {
            this.loadTrackingTree()
            this.trackingMap = new Map()
            this.onCancel()
          }
          if (this.opStatus === 'add') {
            this.loadTrackingTree()
          }
          this.opStatus = 'read'
          this.optModule.tracking = false
        }).finally(() => {
          this.loading.close()
        })
      }
      if (this.optModule.trackingDetail) {
        // 保存节点状态
        await this.checkTrackingDetailForm()
        const body = deepClone(this.trackingDetail)
        if (!this.checkSopMessageSetting()) {
          return
        }
        const isNoAddAlert = this.opStatus === 'add' && (!body.warningRuleVO.warningRuleItemList || body.warningRuleVO.warningRuleItemList.length === 0)
        const hasAlert = body.warningRuleVO.open === null
        if (isNoAddAlert || hasAlert) {
          body.warningRuleVO = ''
        }
        if (body.warningRuleVO) {
          body.warningRuleVO.lob = this.lob
        }
        if (body.warningRuleVO.warningRuleItemList) {
          for (const ruleItem of body.warningRuleVO.warningRuleItemList) {
            if (ruleItem.notifySuperior && !ruleItem.notifierRoles) {
              this.$confirm(this.$t('SystemMaintenance.NotifySuperiorsCheckTip'), this.$t('common.tips.prompt'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                closeOnClickModal: false,
                showClose: false,
                type: 'warning'
              }).then(() => {}).catch(() => {})
              this.activateTab = 'alertSettings'
              return
            }
          }
        }
        body.innerConfig.userList = body.innerConfig.userList.join(',')
        body.innerConfig = JSON.stringify(body.innerConfig)
        if (!body.triggerNodeStateRollback) {
          for (const item of body.nodeStatusRollbackList) {
            if (item.uuid) {
              body.nodeStatusRollbackDelKeys.push(item.uuid)
            }
          }
          body.nodeStatusRollbackList = []
        }
        this.saveChargeSchemeDetailTracking(body)
        this.loading = getLoading()
        saveTrackingDetailInfo(body).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          if (this.opStatus === 'edit') {
            this.loadTrackingTree()
            this.trackingDetailMap = new Map()
            this.onCancel()
          }
          if (this.opStatus === 'add') {
            this.loadTrackingTree()
          }
          this.opStatus = 'read'
          this.optModule.trackingDetail = false
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    saveChargeSchemeDetailTracking(body) {
      const params = {}
      const list = []
      if (body.chargeSchemeDetailTrackingList) {
        for (const d of body.chargeSchemeDetailTrackingList) {
          if (!d.parentUuid) {
            list.push(d.uuid)
          }
        }
      }
      params.cUuid = list
      body.chargeSchemeDetailTrackingVO = params
    },
    reloadTemplateTree(name, serialNumber) {
      const node = this.selectTemplateRow()
      node.data.chineseName = name
      node.data.serialNumber = serialNumber
      this.trackingTemplateTree.gridOptions.api.refreshCells({ force: true })
    },
    reloadTrackingTree(name, level) {
      const node = this.selectTrackingRow()
      node.data.chineseName = name
      node.data.level = level
      this.trackingTree.gridOptions.api.refreshCells({ force: true })
    },
    checkSopMessageSetting() {
      const configVOs = this.trackingDetail.trackingTemplateConfigVOList
      if (configVOs && configVOs.length > 0) {
        const map = {}
        for (const config of configVOs) {
          const key = config.pushObject + config.pushChannel
          if (map.hasOwnProperty(key)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SOPPushObjectChannelRepeats'))
            return false
          }
          map[key] = true
          config.pushNode = this.trackingDetail.codeCname
          if (config.pushChannel === 0 || config.pushChannel === 2) {
            // email
            if (config.pushChannel !== 2 && StrUtils.isEmpty(config.templateTitle)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterAThemeTemplate'))
              return false
            }
            if (StrUtils.isEmpty(config.templateText)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterTheBodyTemplateContent'))
              return false
            }
          } else {
            config.fileId = ''
            if (StrUtils.isEmpty(config.templateTitle2Note)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterTheTemplateContent'))
              return false
            }
            if (StrUtils.isEmpty(config.templateText2Note)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterAnExampleTemplate'))
              return false
            }
          }
        }
      }
      return true
    },
    onCancel() {
      if (this.opStatus === 'add' || this.opStatus === 'edit') {
        // 原新增或编辑时，重新获取当前选中行数据加载
        const node = this.selectTrackingRow()
        if (node) {
          this.toMountView(node.data, node, [1, 2].includes(node.data.type) ? 'tracking' : 'trackingDetail')
        } else {
          this.optModule.tracking = false
          this.optModule.trackingDetail = false
        }
      }
      this.opStatus = 'read'
    },
    getParentUuid() {
      const node = this.selectTrackingRow()
      return node.data['parentUuid'] ? node.data['parentUuid'] : node.data.uuid
    },
    getTrackingCode() {
      const tracking = this.getTracking()
      return tracking.code || ''
    },
    getTracking() {
      const trackingKey = this.getParentUuid()
      const tracking = this.trackingTree.rowData.filter(item => item.path === trackingKey)
      return tracking[0]
    },
    // 获取同节点下新的节点状态序号
    getNewTrackingDetailLevel() {
      const parentUuid = this.getParentUuid()
      const details = this.trackingTree.rowData.filter(item => item.parentUuid === parentUuid)
      if (!details || details.length === 0) {
        return 1
      }
      return details.sort((a, b) => Number(b.level) - Number(a.level))[0].level + 1
    },
    // 获取同节点下新的节点状态序号
    getLevel(list) {
      const details = list.rowData.filter(item => !item.parentUuid)
      if (!details || details.length === 0) {
        return 1
      }
      return details.sort((a, b) => Number(b.level) - Number(a.level))[0].level + 1
    },
    // 获取同节点下新的节点状态序号
    getSopTemplateLevel(list, lob) {
      const details = list.rowData.filter(item => item.parentUuid === lob)
      if (!details || details.length === 0) {
        return 1
      }
      const level = details.sort((a, b) => Number(b.serialNumber) - Number(a.serialNumber))[0].serialNumber
      return parseInt(level) + 1
    },
    selectTrackingRow() {
      const cell = this.trackingTree.gridOptions.api.getFocusedCell()
      const nodes = this.trackingTree.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      return node
    },
    selectTemplateRow() {
      const cell = this.trackingTemplateTree.gridOptions.api.getFocusedCell()
      const nodes = this.trackingTemplateTree.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      return node
    },
    async loadPlatformInfo() {
      const lob = this.lob
      if (!this.platformData.hasOwnProperty(lob) && !this.isPlatform) {
        await getPlatformSopInfo({ lob: lob }).then(res => {
          this.platformData[lob] = res.data
        })
      }
      if (!this.fileTreeMap.hasOwnProperty(lob)) {
        getDocCategoryTypeTreeByLob({ lob: lob, constructLobParent: false }).then(res => {
          this.fileTreeMap[lob] = res.data
        })
      }
      if (!this.docTypeMap.hasOwnProperty(lob)) {
        getDocTypeByLob(lob).then(res => {
          this.docTypeMap[lob] = res.data
        })
      }
    },
    async checkTrackingForm() {
      const { code, nodeType, codeCname, codeEname } = { ...this.tracking }
      const psInput = this.$t('CargoMsg.Cargo_PlsInput')
      await Assert.isNotBlank(code, psInput + this.$t('CargoMsg.Cargo_Code'))
      await Assert.isNotBlank(nodeType, psInput + this.$t('CargoMsg.Cargo_NodeType'))
      await Assert.isNotBlank(codeCname, psInput + this.$t('CargoMsg.Cargo_ChineseNamed'))
      await Assert.isNotBlank(codeEname, psInput + this.$t('CargoMsg.Cargo_EnglishNamed'))
      await this.$refs.nodeSettings.saveCheck()
    },
    async checkTrackingDetailForm() {
      const { code, stateType, event, type, codeCname, codeEname, triggerNodeStateRollback, nodeStatusRollbackList } = { ...this.trackingDetail }
      const psInput = this.$t('CargoMsg.Cargo_PlsInput')
      await Assert.isNotBlank(code, psInput + this.$t('CargoMsg.Cargo_Code'))
      await Assert.isNotBlank(codeCname, psInput + this.$t('CargoMsg.Cargo_ChineseNamed'))
      await Assert.isTrue(codeCname.length < 20, this.$t('SystemMaintenance.ChineseNameLengthExceeds20'))
      await Assert.isNotBlank(codeEname, psInput + this.$t('CargoMsg.Cargo_EnglishNamed'))
      await Assert.isNotBlank(stateType, this.$t('SystemMaintenance.PleaseSelectStatusType'))
      await Assert.isTrue(!type || event, this.$t('SystemMaintenance.PleaseSelectTriggerType'))
      if (triggerNodeStateRollback) {
        // 状态类型不等于未开始和异常
        await Assert.isTrue(stateType === 1 || stateType === 4, this.$t('SystemMaintenance.RollbackBeSetOnlyStartedAbnormal'))
        await Assert.isTrue(nodeStatusRollbackList.length > 0, this.$t('SystemMaintenance.PleaseNodeThatNeedsTriggered'))
        for (const item of nodeStatusRollbackList) {
          await Assert.isNotBlank(item.trackingCode, this.$t('SystemMaintenance.TheNodeCannotBeEmpty'))
          await Assert.isNotBlank(item.trackingDetailCode, this.$t('SystemMaintenance.TheStatusCannotBeEmpty'))
        }
      }
    },
    hasChoosePerson(innerConfig, designatedPosts) {
      if (innerConfig.userList && innerConfig.userList.length > 0) {
        return true
      }
      for (const post of designatedPosts) {
        if (innerConfig[post]) {
          return true
        }
      }
      return false
    },
    /**
     * 解析模板的节点code,节点状态code
     * @param trackingTree
     * @param sopTemplateUuid
     */
    parsingCode(trackingTree, sopTemplateUuid) {
      const codeList = []
      if (trackingTree && trackingTree.length > 0) {
        const treeMap = {}
        for (const element of trackingTree) {
          treeMap[element.uuid] = element
        }
        for (const element of trackingTree) {
          if (element.parentUuid) { // 父节点不为空
            const parent = treeMap[element.parentUuid]
            if (parent) {
              codeList.push('CODE = \'' + parent.code + '\' AND SUB_CODE = \'' + element.code + '\'')
            }
          }
        }
      }
      this.sopTemplateCodeMap[sopTemplateUuid] = codeList
    },
    // 刷新
    refresh(tracking = null) {
      if (!tracking) return
      if (this.trackingTree.rowData) {
        for (const item of this.trackingTree.rowData) {
          if (item.uuid === tracking.uuid) {
            item.documentId = tracking.documentId
            break
          }
        }
      }
      if (this.trackingMap.has(tracking.uuid)) {
        const item = this.trackingMap.get(tracking.uuid)
        item.documentId = tracking.documentId
        this.trackingMap.set(tracking.uuid, item)
      }
    },
    // 更新sop模板状态确认弹窗
    async updateTenantSopStatusConfirm() {
      let flag = false
      let msg = this.$t('CargoMsg.Cargo_EnableSopTemplateConfirm')
      if (this.trackingTemplate.sopStatus) {
        msg = this.$t('CargoMsg.Cargo_UnableSopTemplateConfirm')
      }
      await this.$confirm(msg, this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        showClose: false,
        type: 'warning'
      }).then(async() => {
        flag = true
      }).catch(() => {
        flag = false
      })
      return flag
    },
    // 更新sop模板状态
    async onUpdateTenantSopStatus() {
      const flag = await this.updateTenantSopStatusConfirm()
      if (!flag) {
        return
      }
      if (this.trackingTemplate.sopStatus) {
        this.trackingTemplate.sopStatus = false
      } else {
        this.trackingTemplate.sopStatus = true
      }
      this.loading = getLoading()
      await updateTenantSopStatus({ sopStatus: this.trackingTemplate.sopStatus, uuid: this.trackingTemplate.uuid }).then(async res => {

      }).finally(() => {
        this.updateTenantSopStatusDialog.visible = false
        this.loading.close()
      })
      const node = this.selectTemplateRow()
      node.data.sopStatus = this.trackingTemplate.sopStatus
      this.trackingTemplateTree.gridOptions.api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-disable{
  pointer-events: none;
}
</style>
